import { ResolveRiskSummary } from "services/asset-management/AssetGradingService";
import { RiskSummary } from "services/asset-management/AssetService";

export const calculateTotalAssetsCount = (data: ResolveRiskSummary): number =>
    data.assetsExcludingLockedAndQuarantinedCount +
    data.lockedAssetsCount +
    data.quarantinedAssetsCount -
    data.lockedAndQuarantinedAssetsCount;

export const toRiskSummary = (data: ResolveRiskSummary): RiskSummary => ({
    totalLow: data.assetsExcludingLockedAndQuarantinedCount,
    totalMedium: data.lockedAssetsCount,
    totalHigh: data.quarantinedAssetsCount - data.lockedAndQuarantinedAssetsCount,
    total: calculateTotalAssetsCount(data),
});
